module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHUlEQVQIW2NgY2OzYUACYL6+vn4UsgAynwwBEB8ARuIGpsZxGOoAAAAASUVORK5CYII="